import React, {Fragment, Component} from 'react';
import OpportunityRow from './OpportunityRow';
import EmptyState from './EmptyState';
import Pagination from '../../shared/components/Pagination';
import Loading from "../../shared/components/misc/Loading";

class OpportunitiesTable extends Component{
  constructor(props) {
    super(props)

    this.renderPagination = this.renderPagination.bind(this);
    this.renderTable = this.renderTable.bind(this);
  }

  renderSortIcon(header_sort_key) {
    const { sort_key, sort_direction } = this.props.sort_params;

    const activeHeader = sort_key === header_sort_key

    return (
      <div className="sortIcons">
        <i className={`materialIcon --small ${ activeHeader && sort_direction !== "DESC" ? "active" : ""}`}>
          arrow_drop_up
        </i>
        <i className={`materialIcon --small ${ activeHeader && sort_direction === "DESC" ? "active" : ""}`}>
          arrow_drop_down
        </i>
      </div>
    )
  }

  renderPagination() {
    if (!this.props.hidePagination) {
      const {
        totalPages,
        totalCount,
        currentPage,
        handlePageClick,
        handleFastRewindClick,
        handleNextButtonClick,
        handlePreviousButtonClick,
        handleFastForwardClick,
      } = this.props;

      return (
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          totalCount={totalCount}
          handlePageClick={handlePageClick}
          handleFastRewindClick={handleFastRewindClick}
          handlePreviousButtonClick={handlePreviousButtonClick}
          handleNextButtonClick={handleNextButtonClick}
          handleFastForwardClick={handleFastForwardClick}
        />
      )
    }
  }

  renderTable() {
    const {
      opportunities,
      loading,
      handleSort,
    } = this.props;

    if (loading) return <Loading />

    if (opportunities.length > 0) {
      return (
        <div className="ds-card projects-table-card">
          {this.renderPagination()}
          <section className="cardSection table-section">
            <table id="projects-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort("project_name")}>
                    Project Name
                  </th>
                  <th onClick={() => handleSort("project_name")}>
                    {this.renderSortIcon("project_name")}
                  </th>
                  <th onClick={() => handleSort("bid_amount")}>
                    Amount
                  </th>
                  <th onClick={() => handleSort("bid_amount")}>
                    {this.renderSortIcon("bid_amount")}
                  </th>
                  <th onClick={() => handleSort("address")}>
                    Address
                  </th>
                  <th onClick={() => handleSort("address")}>
                    {this.renderSortIcon("address")}
                  </th>
                  <th>Procuring Entity</th>
                  <th>Posting Date</th>
                  <th onClick={() => handleSort("closing_date")}>
                    Closing Date
                  </th>
                  <th onClick={() => handleSort("closing_date")}>
                    {this.renderSortIcon("closing_date")}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <Fragment>
                  {opportunities.map(opportunity => {
                    return (
                      <OpportunityRow
                        key={opportunity.bid_id}
                        {...opportunity}
                      />
                    );
                  })}
                </Fragment>
              </tbody>
            </table>
          </section>
          {this.renderPagination()}
        </div>
      );
    } else {
      return (
        <EmptyState message="No available Opportunities"/>
      )
    }
  }

  render() {
    return(
      this.renderTable()
    )
  }
}

export default OpportunitiesTable;



// WEBPACK FOOTER //
// ./src/features/projectFinder/components/OpportunitiesTable.js